import React from 'react'
import styles from './styles.module.css'

export default function ReportModal({ report, onClose }) {
  const { group_title, row_title, items = [] } = report || {}

  const groups = []
  const groupByTitle = new Map()
  items.forEach((item) => {
    let group = groupByTitle.get(item.title)
    if (!group) {
      group = { title: item.title, rows: [] }
      groupByTitle.set(item.title, group)
      groups.push(group)
    }
    group.rows.push(item)
  })
  groups.forEach((g) => g.rows.sort((a, b) => (a.sorting || 0) - (b.sorting || 0)))

  return (
    <div className={styles.reportOverlay} onClick={onClose}>
      <div className={styles.reportBox} onClick={(e) => e.stopPropagation()}>
        <div className={styles.reportHead}>
          Предметы и классы по учебной структуре
          <span className={styles.reportClose} onClick={onClose}>✕</span>
        </div>
        <div className={styles.reportScroll}>
          {groups.length
            ? groups.map((group, gi) => (
                <div key={gi} className={styles.reportGroup}>
                  <div className={styles.reportGroupTitle}>{group_title}: {group.title}</div>
                  <table className={styles.reportTable}>
                    <thead>
                      <tr>
                        <th>{row_title}</th>
                        <th>Преподаватель</th>
                      </tr>
                    </thead>
                    <tbody>
                      {group.rows.map((row, ri) => (
                        <tr key={ri}>
                          <td>{row.row_value}</td>
                          <td>{row.teacher || '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))
            : <p style={{ textAlign: 'center', color: '#9aa7b8', padding: '16px' }}>Нет данных</p>
          }
        </div>
        <div className={styles.reportFoot}>
          <button className={styles.reportCloseBtn} onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  )
}
